/**
 * OutlineContent  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { ITreeNode, TREE_NODE_ACTION_STYLE } from "../../ui/components/Tree/TreeViewTypes";
import { TreeView } from "../../ui/components/Tree/TreeView";
import { useTreeState } from "../../ui/components/Tree/useTreeState";
import { useTreeSelections } from "../../ui/components/Tree/useTreeSelections";

export interface OutlineContentProps {}

const items: ITreeNode[] = [
	{
		id: "a",
		label: "View",
		icon: "mdi/selection",
		tooltip: "first thing",
		description: "first description",
		isSelected: false,
		defaultExpanded: true,
		selectable: true,
		actions: [
			{
				icon: "mdi/plus",
				tooltip: "aaaa",
				disabled: false,
				style: TREE_NODE_ACTION_STYLE.DEFAULT,
				hasPrimaryAction: true
			}
		],
		children: [
			{
				id: "aa",
				label: "todoListItems",
				icon: "mdi/database",
				tooltip: "first first thing",
				description: "items",
				isSelected: false,
				defaultExpanded: false
			},
			{
				id: "ab",
				label: "headerContainer",
				icon: "mdi/texture-box",
				tooltip: "first second thing",
				description: "component",
				isSelected: false,
				defaultExpanded: false,
				children: [
					{
						id: "aba",
						label: "newTodoInput",
						icon: "mdi/form-textbox",
						tooltip: "first third thing",
						description: "input",
						isSelected: false,
						defaultExpanded: false
					},
					{
						id: "abb",
						label: "addTodoButton",
						icon: "mdi/card-outline",
						tooltip: "first third thing",
						description: "button",
						isSelected: false,
						defaultExpanded: false
					}
				]
			},
			{
				id: "ac",
				label: "todoList",
				icon: "mdi/texture-box",
				tooltip: "first third thing",
				description: "list",
				isSelected: false,
				defaultExpanded: false,
				children: [
					{
						id: "aca",
						label: "doneCheckbox",
						icon: "mdi/checkbox-marked-outline",
						tooltip: "first third thing",
						description: "checkbox",
						isSelected: false,
						defaultExpanded: false
					},
					{
						id: "acb",
						label: "itemLabel",
						icon: "mdi/text",
						tooltip: "first third thing",
						description: "label",
						isSelected: false,
						defaultExpanded: false
					},
					{
						id: "acc",
						label: "deleteButton",
						icon: "mdi/card-outline",
						tooltip: "first third thing",
						description: "button",
						isSelected: false,
						defaultExpanded: false
					}
				]
			}
		]
	}
];

export const OutlineContent: React.FC<OutlineContentProps> = () => {
	const logEvent = React.useCallback((...args) => {
		console.log(...args);
	}, []);

	const [ selections, selectNode ] = useTreeSelections();
	const [ treeState, handleTreeStateUpdate ] = useTreeState();

	return (
		<div>
			<TreeView
				items={items}
				state={treeState}
				multiselect
				isDraggable
				onNodeDragDrop={logEvent}
				selections={selections}
				onNodeSelect={selectNode}
				onNodeFlagClick={logEvent}
				onStateUpdate={handleTreeStateUpdate}
			/>
		</div>
	);
};
